"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILBanner = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_box_common_1 = require("../il-box/il-box.common");
var il_form_label_common_1 = require("../il-form-label/il-form-label.common");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var ILBanner = function (props) {
    var color = "".concat(props.color, ".main");
    var classes = 'il-banner ' + props.className;
    return (react_1.default.createElement(il_box_common_1.ILFormBox, { className: classes, sx: __assign(__assign(__assign({}, il_box_common_1.ILFormBoxArgs.sx), { borderLeftWidth: 8, borderLeftColor: color, borderLeftStyle: 'solid', borderRadius: 2, padding: { sm: '1rem 0.5rem', md: '1.2rem 0.75rem' } }), props.sx) },
        react_1.default.createElement(material_1.Grid, { container: true, direction: "row", wrap: "nowrap", spacing: 2, alignItems: "center" },
            react_1.default.createElement(material_1.Grid, { item: true },
                react_1.default.createElement(material_1.Avatar, { sx: { bgcolor: color } }, props.icon || react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: props.iconType }))),
            (props.title || props.description) && (react_1.default.createElement(material_1.Grid, { item: true, container: true, direction: "column" },
                react_1.default.createElement(il_form_label_common_1.BoldFormLabel, { sx: __assign(__assign(__assign({}, il_form_label_common_1.BoldFormLabelArgs.sx), { color: 'text.primary' }), props.titleSx) }, props.title),
                react_1.default.createElement(material_1.Typography, { sx: {
                        fontSize: 'button.fontSize',
                        textTransform: 'unset',
                    }, color: "text.secondary", variant: enums_1.TypographyVariantEnum.BODY2 }, props.description))),
            props.children)));
};
exports.ILBanner = ILBanner;
